/* Aniversário V7 — reconcilia o estado do desconto responsivo com o carrinho real.
   O Liquid pinta o primeiro estado; este script é a AUTORIDADE depois disso
   (proteção contra page cache) e reage ao evento 'cart:update' do tema
   (ThemeEvents.cartUpdate === 'cart:update', assets/events.js). Display-only. */
(function () {
  var S = window.AnivDesconto;
  if (!S || !S.ativo) return;

  /* 04/08: conta só o que a REGRA do Shopify conta — os itens dentro da coleção que as 4
     regras ANIVERSÁRIO escopam. Antes era uma denylist feita à mão (S.semBoost) que não
     conhecia produtos fora da coleção: com `lencol-hoomy-unidade` no carrinho o display
     prometia a faixa de 4 peças (R$571,37) e a loja cobrava a de 3 (R$587,70).
     A allowlist vem do Liquid em S.escopo — o /cart.js não expõe coleção. */
  function noEscopo(handle) {
    return !!handle && Array.isArray(S.escopo) && S.escopo.indexOf(handle) !== -1;
  }

  function pecasPagas(cart) {
    var total = 0;
    (cart.items || []).forEach(function (it) {
      var gift = S.brindeProp && S.brindeProp.key && it.properties &&
        it.properties[S.brindeProp.key] === S.brindeProp.val;
      if (!gift && noEscopo(it.handle)) total += it.quantity;
    });
    return total;
  }

  /* Faixa da escada pra um total de peças. Tabela E clamp vêm do Liquid (S.faixaPara,
     emitido inline no <head> pelo snippet aniv-discount-state) pra não existir uma 2ª
     cópia da regra aqui — o pdp-bundle chama a MESMA função. */
  function faixaPara(total) {
    return typeof S.faixaPara === 'function' ? S.faixaPara(total) : 0;
  }

  /* Thiago, 03/08 (resposta ao PDF "Super review do site"): o percentual exibido é o da
     faixa que a superfície ALCANÇA se o cliente aceitar a oferta — não um boost binário.
     Card de produto soma 1 peça; banner "escolha duas unidades" soma 2. Com 2 no carrinho
     o card passa a dizer 30% (3ª peça) e o banner 32% (4ª). `data-aniv-add` permite
     declarar quantas peças a superfície adiciona; default 1 no badge e 2 no inline.
     PISO de 30% (decisão de 03/08; era 28% até 04/08): carrinho vazio nunca mostra os 12%
     de uma peça. */
  function pctPara(pecas, somaDefault, el) {
    var add = parseInt(el && el.getAttribute('data-aniv-add'), 10);
    if (!add || add < 1) add = somaDefault;
    var p = faixaPara(pecas + add);
    return p < S.faixaBase ? S.faixaBase : p;
  }

  function aplicar(pecas) {
    /* 05/08: o evento passou a disparar quando a CONTAGEM muda, não só quando o boost
       vira. Quem deriva percentual de `S.pecas` (pdp-bundle, bundle-builder) ficava com o
       número velho ao ir de 2 pra 3 peças — dentro da mesma faixa binária, mas em degraus
       diferentes da escada. */
    var pecasMudou = pecas !== S.pecas;
    S.pecas = pecas;
    var boost = pecas >= S.gatilho;
    var mudou = boost !== S.boost || pecasMudou;
    S.boost = boost;
    document.documentElement.toggleAttribute('data-aniv-boost', boost);
    document.querySelectorAll('[data-aniv-pct-badge]').forEach(function (el) {
      el.textContent = pctPara(pecas, 1, el) + '% OFF';
    });
    document.querySelectorAll('[data-aniv-pct-inline]').forEach(function (el) {
      el.textContent = 'ganhe ' + pctPara(pecas, 2, el) + '% OFF';
    });
    document.querySelectorAll('[data-aniv-notice]').forEach(function (el) {
      el.hidden = !boost;
    });
    if (mudou) document.dispatchEvent(new CustomEvent('aniv:discount-state', { detail: S }));
  }

  /* 14/08/2026 — a allowlist do Liquid pode chegar INCOMPLETA, e o Liquid não tem como
     completá-la sozinho. Dois limites se somam:

     1) `collection.products` num `for` sem paginate devolve no máximo 50. A coleção de
        escopo tem 52, então o teto morde. Paginate não resolve: ele é dirigido pelo
        ?page= da URL, e `offset` opera sobre os 50 que já vieram.
     2) Medido no Admin em 14/08: dos 52 produtos da coleção, 36 são ACTIVE e 16 são
        UNLISTED (os sósias de order bump, up-sell e os PV: `*-ob`, `*-up`, `pv-*`,
        `*-mtrc-*`). Produto UNLISTED é vendável por link direto mas some das listagens.

     Por isso publicamos `escopoTotal` (que vem de `all_products_count` e conta os 52 sem
     passar pelo `for`): comparar os dois é o único jeito de SABER que a lista está curta.
     Quando está, buscamos a coleção pelo storefront e fazemos UNIÃO — nunca substituição.
     União porque o products.json também só devolve os ACTIVE: trocar uma lista pela outra
     poderia ENCOLHER o escopo. Unir só pode aumentar, e a direção da falha continua sendo
     a segura (handle ausente = não conta peça = a superfície anuncia MENOS do que a loja
     cobra; o inverso, anunciar sem conceder, segue impossível por esta via).

     Falha de rede mantém a lista do Liquid. sessionStorage evita repetir o fetch a cada
     'cart:update'. */
  var ESCOPO_CACHE_KEY = 'aniv:escopo:' + (S.escopoTotal || 0);

  function listaCompleta() {
    return !Array.isArray(S.escopo) || !S.escopoTotal || S.escopo.length >= S.escopoTotal;
  }

  function unir(handles) {
    if (!Array.isArray(handles) || !handles.length) return;
    var vistos = {};
    var out = [];
    /* 20/08 (PEÇA-FANTASMA): produto ISENTO da campanha (aniv-oferta -> 'fora_campanha') não
       pode voltar pela união. O products.json da coleção ainda o traz — quem sabe que ele é
       isento é o Liquid, que publica `isentos` junto. Sem isto, o candidato reentraria no
       escopo e voltaria a contar peça que o motor não conta. */
    var isentos = Array.isArray(S.isentos) ? S.isentos : [];
    (S.escopo || []).concat(handles).forEach(function (h) {
      if (h && !vistos[h] && isentos.indexOf(h) === -1) { vistos[h] = true; out.push(h); }
    });
    S.escopo = out;
  }

  function completarEscopo() {
    if (listaCompleta()) return Promise.resolve();

    try {
      var cache = sessionStorage.getItem(ESCOPO_CACHE_KEY);
      if (cache) { unir(JSON.parse(cache)); return Promise.resolve(); }
    } catch (e) { /* storage bloqueado = segue pro fetch */ }

    return fetch('/collections/' + S.escopoHandle + '/products.json?limit=250')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !Array.isArray(data.products)) return;
        var handles = data.products.map(function (p) { return p.handle; });
        unir(handles);
        try { sessionStorage.setItem(ESCOPO_CACHE_KEY, JSON.stringify(handles)); } catch (e) {}
      })
      .catch(function () { /* mantém a lista do Liquid */ });
  }

  function sync() {
    completarEscopo().then(function () {
      return fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { aplicar(pecasPagas(cart)); });
    }).catch(function () { /* sem rede = mantém o estado do Liquid */ });
  }

  document.addEventListener('cart:update', sync);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
